import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import langMap from '../../langMap';

const SecondaryMenuLink = ({ lang, item, edition }) => (
  <li className="c-website-menu-list__item  website-menu--secondary__list__item">
    <Link
      activeClassName="active"
      className="c-website-menu__list__link website-menu--secondary__list__link"
      to={lang === 'ar' ? `/ar/${item}?edition=${edition}` : `/${item}?edition=${edition}`}
    >
      {lang === 'ar' ? langMap[item].arabic : langMap[item].full}
    </Link>
  </li>
);

SecondaryMenuLink.propTypes = {
  edition: PropTypes.string.isRequired,
  item: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
};

export default SecondaryMenuLink;



// WEBPACK FOOTER //
// ./js/components/menus/SecondaryMenuLink.js